import React from 'react';
import { cn } from '@/lib/utils';
import './styles/input.css';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, ...props }, ref) => (
    <input ref={ref} className={cn('form-input', className)} {...props} />
  )
);

Input.displayName = 'Input';
